import { Button } from '@zyxantech/tux'
import { AlertTriangle } from 'lucide-react'

export interface ErrorStateProps {
  /** RTK Query error or any thrown value; rendered as a friendly message. */
  error?: unknown
  title?: string
  retry?: () => void
}

/** Extract a human-readable message from an RTK Query / unknown error. */
function messageOf(error: unknown): string {
  if (typeof error === 'object' && error !== null) {
    if ('data' in error) {
      const data = error.data
      if (typeof data === 'object' && data !== null && 'error' in data) {
        const inner = data.error
        if (typeof inner === 'object' && inner !== null && 'message' in inner) {
          const m = inner.message
          if (typeof m === 'string') return m
        }
      }
    }
    if ('message' in error && typeof error.message === 'string') {
      return (error as { message: string }).message
    }
  }
  return 'Something went wrong while loading this data.'
}

/** Centered error state with a retry action. */
export function ErrorState({ error, title = 'Unable to load', retry }: ErrorStateProps) {
  return (
    <div className="flex min-h-[240px] flex-col items-center justify-center gap-3 p-10 text-center">
      <AlertTriangle className="text-danger" size={28} />
      <div className="text-base font-semibold text-text-primary">{title}</div>
      <p className="max-w-md text-sm text-text-secondary">{messageOf(error)}</p>
      {retry && (
        <Button variant="outline" onClick={retry} className="mt-2">
          Retry
        </Button>
      )}
    </div>
  )
}
